import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from '@Integrations/Users/queries-core'
export function useCurrentUserQueryV1() {
	const result = {
		...useQuery(() => new q.CurrentUserQueryV1())
	}
	return {
		...result,
		runCurrentUserQueryV1: result.run,
		modelCurrentUserQueryV1: result.model,
	}
}

